import { render } from "./AlbumDynamicTopMatter.vue?vue&type=template&id=3034718c&scoped=true&ts=true"
import script from "./AlbumDynamicTopMatter.vue?vue&type=script&lang=ts"
export * from "./AlbumDynamicTopMatter.vue?vue&type=script&lang=ts"

import "./AlbumDynamicTopMatter.vue?vue&type=style&index=0&id=3034718c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3034718c"]])

export default __exports__